import { Plugin } from '@nuxt/types'
import { DefaultOptions } from 'apollo-client/ApolloClient'

const plugin: Plugin = ({ app }) => {
  const apolloProvider = app.apolloProvider as any
  // `process.client` dost work properly while building the APP in nuxt.config
  apolloProvider.defaultOptions = {
    $query: {
      errorPolicy: process.client ? 'all' : 'ignore',
    } as DefaultOptions,
  }
}

export default plugin
